// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'

export const faqFields = gql`
  fragment faqFields on FaqListRecord {
    modelApiKey: _modelApiKey
    firstPublishedAt: _firstPublishedAt
    id
    title
    items {
      answer {
        value
      }
      question
    }
  }
`
